const menus = [
    {
        id: 1,
        name: 'Home',
        namesub: [
            {
                id: 1,
                sub: 'Shop 01',
                links: '/'
            },
            {
                id: 2,
                sub: 'Shop 02',
                links: '/home-02'
            },
            // {
            //     id: 3,
            //     sub: 'Shop 03',
            //     links: '/home-03'
            // },
        ]
    },
    {
        id: 2,
        name: 'About Us',
        namesub: [
            {
                id: 1,
                sub: 'About Us',
                links: '/about-us'
            },
            {
                id: 2,
                sub: 'About Detail',
                links: '/about-detail'
            }
        ],
    },{
        id: 3,
        name: 'Services',
        namesub: [
            {
                id: 1,
                sub: 'Services',
                links: '/services'
            },
            {
                id: 2,
                sub: 'Services Detail',
                links: '/services-detail'
            }
        ],
    },
    {
        id: 4,
        name: 'Projects',
        namesub: [
            {
                id: 1,
                sub: 'Projects',
                links: '/project'
            },
            // {
            //     id: 2,
            //     sub: 'Projects Full Width',
            //     links: '/project-full-width'
            // },
            // {
            //     id: 3,
            //     sub: 'Projects Detail',
            //     links: '/project-detail'
            // }
        ],
    },
    // {
    //     id: 5,
    //     name: 'Page',
    //     namesub: [
    //         {
    //             id: 1,
    //             sub: 'Page Testimonial',
    //             links: '/page-testimonial'
    //         },
    //         {
    //             id: 2,
    //             sub: 'Page Pricing',
    //             links: '/page-pricing'
    //         }
    //     ],
    // },
    // {
    //     id: 6,
    //     name: 'Blog',
    //     namesub: [
    //         {
    //             id: 1,
    //             sub: 'Blog',
    //             links: '/blog'
    //         },
    //         {
    //             id: 2,
    //             sub: 'Blog Single',
    //             links: '/blog-single'
    //         }
    //     ],
    // },
    {
        id: 7,
        name: 'Contact',
        namesub: [
            {
                id: 1,
                sub: 'Contact 1',
                links: '/contact-01'
            },
            // {
            //     id: 2,
            //     sub: 'Contact 2',
            //     links: '/contact-02'
            // }
        ],
    }
]

export default menus;